import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Dropdown,
  Spinner,
  Container,
} from "react-bootstrap";
import {
  FaPlus,
  FaSyncAlt,
  FaFilter,
} from "react-icons/fa";
import config from "../../config";
import Layout from "../../components/layouts/Main";
import { Link } from "react-router-dom";
import ProductionRequestTable from "../../components/productionRequests/ProductionRequestTable";

function ProductionRequestList() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterStatus, setFilterStatus] = useState("ALL");

  // Fetch Production Requests
  const fetchRequests = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${config.API_BASE_URL}/production-requests`);
      const data = await res.json();
      setRequests(data);
    } catch (error) {
      console.error("Failed to fetch production requests:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  // Filtered Requests
  const filteredRequests =
    filterStatus === "ALL"
      ? requests
      : requests.filter((r) => r.status === filterStatus);

  // Handlers
  const handleView = (req) => {
    // Navigation handled by Link in table
  };

  const handleEdit = (req) => {
    // Only available for PENDING status
    if (req.status === "PENDING") {
      alert(`Edit ${req.requestNumber}`);
      // Navigate to edit page
    }
  };

  const handleDelete = async (req) => {
    // Only available for PENDING status
    if (req.status !== "PENDING") return;
    
    if (!window.confirm(`Are you sure you want to delete ${req.requestNumber}?`)) return;
    try {
      await fetch(`${config.API_BASE_URL}/production-requests/${req._id}`, {
        method: "DELETE",
      });
      fetchRequests();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  return (
    <Layout>
      <nav aria-label="breadcrumb" className="mb-3">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/">Dashboard</Link>
          </li>
          <li className="breadcrumb-item active">Production Requests</li>
        </ol>
      </nav>
      <Container fluid className="my-4">
        <Card className="shadow-sm">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h4 className="mb-0">Production Requests</h4>
            <div className="d-flex gap-2">
              <Dropdown>
                <Dropdown.Toggle variant="outline-secondary" size="sm">
                  <FaFilter className="me-1" /> {filterStatus}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setFilterStatus("ALL")}>
                    All
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setFilterStatus("PENDING")}>
                    Pending
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setFilterStatus("IN_PROGRESS")}>
                    In Progress
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setFilterStatus("COMPLETED")}>
                    Completed
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={fetchRequests}
              >
                <FaSyncAlt className="me-1" /> Refresh
              </Button>
              <Link
                className="btn btn-sm btn-primary"
                to="/production-requests/create"
              >
                <FaPlus className="me-1" /> New Request
              </Link>
            </div>
          </Card.Header>

          <Card.Body>
            {loading ? (
              <div className="text-center p-4">
                <Spinner animation="border" />
              </div>
            ) : (
              <ProductionRequestTable
                requests={filteredRequests}
                onView={handleView}
                onEdit={handleEdit}
                onDelete={handleDelete}
              />
            )}
          </Card.Body>
        </Card>
      </Container>
    </Layout>
  );
}

export default ProductionRequestList;
